import React, { ReactElement, useRef, useState } from 'react';
import Wrapper from '../../../../../../shared/components/Wrapper';
import ClientOneFilter from '../ClienteOneFilter';
import ClientsFilter from '../ClientsFilter';
import ClientsFilterBalance from '../ClientsFilterBalance';
import ButtonSwitchFilter from './components/ButtonSwitchFilter';
import TypeFilterEnum from './enum/TypeFilterEnum';

function Switcher() {
  const keying = useRef(null);

  const [toggleKey, setToggleKey] = useState(TypeFilterEnum.NORMAL);
  let typeFilter: ReactElement;

  switch (toggleKey) {
    case TypeFilterEnum.NORMAL:
      typeFilter = <ClientsFilter />;
      break;

    case TypeFilterEnum.WITHOUTBALANCE:
      typeFilter = <ClientsFilterBalance />;
      break;

    case TypeFilterEnum.ONECLIENT:
      typeFilter = <ClientOneFilter />;
      break;

    default:
      typeFilter = <ClientsFilter />;
  }

  const selectTypeFilter = (option: number) => {
    setToggleKey(option);
  };

  const classButtonActive = 'btn btn-primary btn-filter';
  const classButton = 'btn btn-secondary btn-filter';

  return (
    <>
      <div ref={keying} className="keying">
        {typeFilter}
      </div>
      <Wrapper.Default flexDirection="row" isActive>
        <ButtonSwitchFilter
          text="Filtro comum"
          class={
            toggleKey === TypeFilterEnum.NORMAL
              ? classButtonActive
              : classButton
          }
          actionOnClick={() => selectTypeFilter(TypeFilterEnum.NORMAL)}
        />
        <ButtonSwitchFilter
          text="Filtrar por clientes sem saldo"
          class={
            toggleKey === TypeFilterEnum.WITHOUTBALANCE
              ? classButtonActive
              : classButton
          }
          actionOnClick={() => selectTypeFilter(TypeFilterEnum.WITHOUTBALANCE)}
        />
        <ButtonSwitchFilter
          text="Pesquisar um cliente"
          class={
            toggleKey === TypeFilterEnum.ONECLIENT
              ? classButtonActive
              : classButton
          }
          actionOnClick={() => selectTypeFilter(TypeFilterEnum.ONECLIENT)}
        />
      </Wrapper.Default>
    </>
  );
}

export default Switcher;
